import { render, staticRenderFns } from "./realTimeContent.vue?vue&type=template&id=a1b3946c&scoped=true"
import script from "./realTimeContent.vue?vue&type=script&lang=js"
export * from "./realTimeContent.vue?vue&type=script&lang=js"
import style0 from "./realTimeContent.vue?vue&type=style&index=0&id=a1b3946c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b3946c",
  null
  
)

export default component.exports